import React, { useState, useEffect } from 'react';
import './MainMenu.css';
import { QrReader } from 'react-qr-reader';
import { useNavigate } from 'react-router-dom';
import { FaShoppingBag, FaEye } from 'react-icons/fa';
import en from '../locales/eng.json';
import th from '../locales/th.json';
import CONFIG from '../config';
import PromotionSlider from './PromotionSlider';

import getProfileImage from '../utils/getProfileImage';

function MainMenu() {
  const storedData = localStorage.getItem('userData');
  const navigate = useNavigate(); 
  
  useEffect(() => {
    const lineUserId = localStorage.getItem('line_user_id');
    if (!lineUserId) {
      navigate('/register');
    }
  }, [navigate]);
  const [showScanner, setShowScanner] = useState(false);
const [qrResult, setQrResult] = useState(null);
const [userData, setUserData] = useState(null);
const [showMenu, setShowMenu] = useState(false);
const [earnedExpiry, setEarnedExpiry] = useState(null);

  const [language, setLanguage] = useState(() => {
  return localStorage.getItem('language') || 'TH';
});
const [t, setT] = useState(language === 'EN' ? en : th);

  const profileImage = getProfileImage()

useEffect(() => {
  const fetchUserData = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/lineuser/fetch_user_data?line_user_id=`+ localStorage.getItem('line_user_id'));
      const result = await res.json();

      if (result?.content?.data) {
        setUserData(result.content.data);
      } else {
        throw new Error("Invalid user data format");
      }
    } catch (e) {
      console.error("Failed to fetch user data:", e);
      navigate('/'); // Navigate away if error
    }
  };

  fetchUserData();
}, [navigate]);

useEffect(() => {
  localStorage.setItem('language', language); // Save to localStorage
  setT(language === 'EN' ? en : th);          // Set translation
}, [language]);

  useEffect(() => {
    const fetchPointHistory = async () => {
      try {
        const lineUserId = localStorage.getItem('line_user_id');
        if (!lineUserId) return;

        const res = await fetch(
          `${CONFIG.API_BASE_URL}/linepoint/history?line_user_id=${lineUserId}`,
          {
            headers: { accept: 'application/json' }
          }
        );
        const json = await res.json();
        const history = json?.content?.data || [];

        // Filter only entries where status === "Earned"
        const earnedEntries = history.filter((h) => h.status === 'Earned');
        if (earnedEntries.length === 0) {
          setEarnedExpiry(null);
          return;
        }

        // Find the oldest redeemed_at among those “Earned”
        let oldestDate = earnedEntries[0].redeemed_at;
        for (let entry of earnedEntries) {
          if (new Date(entry.redeemed_at) < new Date(oldestDate)) {
            oldestDate = entry.redeemed_at;
          }
        }

        // Compute expiry as 31/12 of (year received + 1)
        const baseDate = new Date(oldestDate);
        const expiryYear = baseDate.getFullYear() + 1;
        const endOfNextYear = new Date(expiryYear, 11, 31); // month 11 = December

        setEarnedExpiry(endOfNextYear);
      } catch (err) {
        console.error('Failed to fetch point history:', err);
        setEarnedExpiry(null);
      }
    };

    fetchPointHistory();
  }, []);

  useEffect(() => {
    const syncTagsIfNeeded = async () => {
      if (!userData) return;
      const lineUserId = localStorage.getItem('line_user_id') || userData.line_user_id;
      if (!lineUserId) return;

      // Read desired tags from localStorage, then from CONFIG if present.
      // Accept JSON array or comma-separated string. If none provided, default to empty (meaning no sync).
      let desiredTags = [];
      try {
        const stored = localStorage.getItem('tags');
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            desiredTags = Array.isArray(parsed)
              ? parsed.map(String)
              : String(parsed)
                  .split(',')
                  .map((s) => s.trim())
                  .filter(Boolean);
          } catch (e) {
            // if not JSON, treat as comma-separated string
            desiredTags = String(stored)
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean);
          }
        }

        // Fall back to CONFIG.DESIRED_TAGS if available and nothing in localStorage
        if ((!desiredTags || desiredTags.length === 0) && CONFIG && CONFIG.DESIRED_TAGS) {
          const cfg = CONFIG.DESIRED_TAGS;
          if (Array.isArray(cfg)) desiredTags = cfg.map(String);
          else desiredTags = String(cfg).split(',').map((s) => s.trim()).filter(Boolean);
        }
      } catch (e) {
        console.error('Failed to read desired tags from localStorage/CONFIG:', e);
      }

      // If no desired tags specified, skip API calls.
      if (!desiredTags || desiredTags.length === 0) return;

      try {
        const getRes = await fetch(`https://uficon-loop-backend-777160588326.asia-southeast1.run.app/tags/by-line/${lineUserId}`);
        let existingTags = [];
        if (getRes.ok) {
          const json = await getRes.json();
          existingTags = json?.tags || [];
        } else if (getRes.status === 404) {
          existingTags = [];
        } else {
          throw new Error('Failed to fetch existing tags');
        }

        // If any desired tag is already present, skip adding (use 45 OR 48)
        const anyPresent = desiredTags.some((t) => existingTags.includes(t));
        if (anyPresent) return;

        const user_id_txt = String(userData?.user_id ?? userData?.id ?? '');
        const payload = [{
          user_id: user_id_txt,
          phone: userData.phone || '',
          user_name: userData.user_name || userData.name || '',
          line_user_id: lineUserId,
          email: userData.email || '',
          tags: desiredTags
        }];

        await fetch('https://uficon-loop-backend-777160588326.asia-southeast1.run.app/tags/bulk', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      } catch (err) {
        console.error('Tag sync error:', err);
      }
    };

    syncTagsIfNeeded();
  }, [userData]);

  
  return (
    <div>
        <div className="top-section">
    {/* top bar */}
    <div className="top-bar">
      <img onClick={() => navigate('/')} src="/assets/logo-ujoy.png" alt="logo" className="logo-ujoy" />
      <div className="right-section">
        <div className="lang-selector">
          <button
  className={`lang-button ${language === 'TH' ? 'active' : ''}`}
  onClick={() => setLanguage('TH')}
>
  TH
</button>
|
<button
  className={`lang-button ${language === 'EN' ? 'active' : ''}`}
  onClick={() => setLanguage('EN')}
>
  EN
</button>

        </div>


        {showMenu ? 
          <div >
           
 {showMenu && (
  <>
   <img
  onClick={() => navigate('/profile')}
  src="/assets/mascot-full.png"
  alt="avatar"
  style={{ position: 'relative', zIndex: 9998 }} // ADD position
/>
    <div className="menu-overlay" onClick={() => setShowMenu(false)}></div>
    <div className="menu-popup-wrapper">
      <div className="menu-popup">
        <div className="menu-item" onClick={() => { navigate('/my-coupon'); setShowMenu(false); }}>
          <img src="/assets/icon-coupon.png" alt="coupon" />
          <span>คูปองของฉัน</span>
        </div>
        <div className="menu-item" onClick={() => { navigate('/point-redeem'); setShowMenu(false); }}>
          <img src="/assets/icon-redeem.png" alt="redeem" />
          <span>แลกคะแนน</span>
        </div>
        <hr className="dashed-line" />
        <div className="menu-item" onClick={() => { navigate('/point-history'); setShowMenu(false); }}>
          <img src="/assets/icon-points.png" alt="points" />
          <span>คะแนนสะสม</span>
        </div>
        <hr className="dashed-line" />
      </div>
    </div>
  </>
)}


  </div>
  : <div><img
  onClick={() => navigate('/profile')}
  src={
    userData?.line_image_url
      ? userData.line_image_url
      : "/assets/avartar.png"
  }
  alt="avatar"
  className="profile-avatar"
/></div>}


      </div>
    </div>

    {/* greeting and scan */}
    <div className="greeting-scan-section">
      <p className="greeting-text">
        <img src="/assets/smile.png" alt="smile" className="greeting-icon" />
        {t.mainmenu.hi}, {userData?.name || 'Guest'}
      </p>
      <button className="scan-button" onClick={() => setShowScanner(true)}>

        <img src="/assets/qr_code.png" alt="qr icon" className="qr-icon" />
        {t.mainmenu.scan}
      </button>
    </div>

  </div>
    <div className="main-menu-container">


      {/* cloud & member ID */}
      <div className="info-summary-section">
      <div className="cloud-wrapper">
        <img src="/assets/cloud.png" alt="cloud mascot" className="cloud-image" />
      </div>
      

      <div className="member-id-card">
        <br/>
        <p className="member-id-text">Member ID&nbsp;UF{userData?.phone || 'XXXXXXX'}</p>
      </div>
    </div>

  {/* Remaining UI (buttons, etc.) */}
  <div>
  <div
  className="points-image-container"
  onClick={() => navigate('/point-collect')}
>
  <img
    src="/assets/button_point.png"
    alt="point background"
    className="points-image-bg"
  />
  <div className="points-overlay">
    <p className="points-label">{t.mainmenu.points}</p>
    <div className="points-value-row">
      <span className="points-amount">
        {userData?.point?.toLocaleString() || '0'}
      </span>
      <img src="/assets/coin.png" alt="coin" className="coin-icon" />
    </div>
  </div>
</div>


<p className="point-expiry">{userData?.point?.toLocaleString()} {t.mainmenu.points_expiry} {earnedExpiry && (
            <>
               {earnedExpiry.toLocaleDateString('en-GB')}
            </>
          )}</p>

<div className="button-section">
  <button className="outlined-button" onClick={() => navigate('/point-redeem')}>
    <img src="/assets/rewarded_ads.png" alt="redeem" className="button-icon" />
    {t.mainmenu.redeem}
  </button>
  <button className="filled-button" onClick={() =>  navigate('/my-coupon')}>
    <img src="/assets/confirmation_number.png" alt="coupon" className="button-icon" />
    {t.mainmenu.my_coupons}
  </button>
</div>

<div className="purchase-history-section">
  <button
    id="nav-purchases-btn"
    className="purchase-history-button"
    onClick={() => navigate('/purchase-history')}
  >
    <div className="purchase-history-button-left">
      <div className="purchase-history-button-icon-wrap">
        <FaShoppingBag className="purchase-history-button-icon" />
      </div>
      <div className="purchase-history-button-textgroup">
        <span className="purchase-history-button-text">{t.mainmenu.purchase_history}</span>
        <span className="purchase-history-button-subtext">
          {language === 'EN'
            ? 'View bills, tech specs & checkout streams'
            : 'ดูบิลใบเสร็จ รายละเอียดเครื่อง และประวัติการซื้อ'}
        </span>
      </div>
    </div>
    <div className="purchase-history-button-eye">
      <FaEye className="purchase-history-button-eye-icon" />
    </div>
  </button>
</div>



<div className="promotion-wrapper">
  <h2 className="promotion-title">{t.mainmenu.promotion}</h2>
  <div className="promotion-banner">
    <PromotionSlider />
  </div>
</div>

  </div>

  {showScanner && (
  <div className="qr-scanner-overlay">
    <button className="qr-close-button" onClick={() => setShowScanner(false)}>✕</button>
    <QrReader
      constraints={{ facingMode: 'environment' }}
      onResult={(result, error) => {
        if (!!result) {
          setQrResult(result?.text);
          setShowScanner(false);
          window.location.href = result?.text;
        }
      }}
      containerStyle={{ width: '100%', height: '100%' }}
      videoStyle={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
  </div>
)}
</div>
</div>

  );
}

export default MainMenu;